import React, { useContext, useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { ConfigContext } from "../Context/ConfigContext";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from 'primereact/toast';
import axios from 'axios';
import { Avatar } from 'primereact/avatar';
import { motion, AnimatePresence } from "framer-motion";
import './Header.css';
import StoreSelect from "../Components/Store";
import { ProgressBar } from "primereact/progressbar";
import { socket } from "../Components/Options";

const Header = () => {
    const [visible, setVisible] = useState(false);
    const [profileMenuVisible, setProfileMenuVisible] = useState(false);
    const toast = useRef(null);
    const { Logout, apiUrl, apiHeadersJson, user_role, store_id, user_id, set_selected_store_id, set_routes, auth_routes, set_device_id, device_id } = useContext(ConfigContext);
    const headers = apiHeadersJson;
    const [store, setStore] = useState({});
    const [userRoutes, setUserRoutes] = useState([]);
    const [expandedSections, setExpandedSections] = useState({});
    const [showStoreSelect, setShowStoreSelect] = useState(false);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [qrUsers, setQrUsers] = useState([]);

    const location = useLocation();
    const navigate = useNavigate();
    const { order_id, sale_id, employee_sale_id, sale_return_id, purchase_id, purchase_return_id } = useParams()

    const handleNavLinkClick = () => {
        setVisible(false);
    };

    const GetStore = async () => {
        try {
            const response = await axios.get(`${apiUrl}/Others/GetStoreInfo`, { headers });
            const { success, data, message } = response.data;
            if (success && (data.length > 0)) {
                setStore(data[0]);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        }
    };
    const GetRoutes = async () => {
        try {
            const response = await axios.get(`${apiUrl}/User/GetRoutes`, { headers });
            const { success, data, message } = response.data;
            if (success) {
                setUserRoutes(data);
                set_routes(data);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    const handleLogOut = () => {
        setProfileMenuVisible(!profileMenuVisible);
        confirmDialog({
            message: 'Are you sure you want to logout?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => Logout(),
            reject: () => {
                toast.current.show({ severity: 'info', summary: 'Cancelled', detail: 'Logout operation cancelled', life: 3000 });
            },
        });
    };

    const toggleFullScreen = async () => {
        try {
            if (!document.fullscreenElement) {
                await document.documentElement.requestFullscreen();
            } else {
                await document.exitFullscreen();
            }
        } catch (error) {
            console.log('error', error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Fullscreen mode is not available', life: 3000 });
        }
    };

    const toggleSection = (sectionName) => {
        setExpandedSections((prev) => ({
            ...prev,
            [sectionName]: !prev[sectionName],
        }));
    };

    const sendMessageToDevice = () => {

        if (!device_id) {
            toast.current.show({
                severity: "warn",
                summary: "Warning",
                detail: "Please select QR screen",
                life: 3000
            });

            return;
        }

        socket.emit("send_message_to_device", {
            store_id,
            user_id: device_id,
            message: "Hello QR Device"
        });

        toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Request sent to device successfully",
            life: 3000
        });
    };

    useEffect(() => {
        GetStore();
    }, [store_id]);

    useEffect(() => {
        GetRoutes();
        setVisible(true);
    }, [user_id]);

    useEffect(() => {
        if (order_id || sale_id || employee_sale_id || sale_return_id || purchase_id || purchase_return_id) {
            setShowStoreSelect(false);
        } else {
            setShowStoreSelect(true);
        }
    }, [order_id, sale_id, employee_sale_id, sale_return_id, purchase_id, purchase_return_id]);

    useEffect(() => {
        const handleFullScreenChange = () => {
            setIsFullScreen(Boolean(document.fullscreenElement));
        };

        document.addEventListener('fullscreenchange', handleFullScreenChange);
        return () => document.removeEventListener('fullscreenchange', handleFullScreenChange);

    }, []);


    useEffect(() => {
        if (store && store?.store?.store_logo_url) {
            const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'icon';
            link.href = './assets/logo.ico';
            document.getElementsByTagName('head')[0].appendChild(link);
            document.title = "QuickInventory";
        }
    }, [store]);

    const routes = [
        {
            path: "/",
            name: "Dashboard",
            icon: "pi pi-home",
            routename: "Dashboard",
        },
        {
            name: "Masters",
            icon: "pi pi-database",
            routename: "Masters",
            children: [
                { path: "/Store", name: "Store", routename: "Store" },
                { path: "/Category", name: "Category", routename: "Category" },
                { path: "/Product", name: "Products", routename: "Products" },
                { path: "/ImportProducts", name: "Import Products", routename: "ImportProducts" },
                { path: "/Expenses", name: "Expenses", routename: "Expenses" },
                { path: "/Customers", name: "Customers", routename: "Customers" },
                { path: "/Users", name: "Users", routename: "Users" },
                { path: "/OfferTime/1", name: "Offer Time", routename: "OfferTime" },
                { path: "/Supplier", name: "Suppliers", routename: "Suppliers" },
                { path: "/Upis", name: "Upis", routename: "Upis" },
            ],
        },
        {
            name: "Entries",
            icon: "pi pi-pencil",
            routename: "Entries",
            children: [
                { path: "/Purchase", name: "Purchase", routename: "Purchase" },
                { path: "/StockTransfer", name: "Stock Transfer", routename: "StockTransfer" },
                { path: "/Sales", name: "Sales", routename: "Sales" },
                { path: "/EmployeeSales", name: "Employee Sales", routename: "EmployeeSales" },
                { path: "/ExpensesEntry", name: "Expenses", routename: "ExpensesEntry" },
                { path: "/OrdersEntry", name: "Orders", routename: "OrdersEntry" },
            ],
        },
        {
            name: "Return Entries",
            icon: "pi pi-undo",
            routename: "Return Entries",
            children: [
                { path: "/SalesReturn", name: "Sales Return", routename: "SalesReturn" },
                { path: "/PurchaseReturn", name: "Purchase Return", routename: "PurchaseReturn" },
            ],
        },
        {
            name: "Reports",
            icon: "pi pi-folder-open",
            routename: "Reports",
            children: [
                { path: "/PurchaseReports/30/DESC", name: "Purchase Report", routename: "PurchaseReport" },
                { path: "/SaleReports/30/DESC", name: "Sales Report", routename: "SalesReport" },
                { path: "/EmployeeSalesReport/30/DESC", name: "Employee Sales Report", routename: "EmployeeSalesReport" },
                { path: "/StockTransferReports/30/DESC", name: "Stock Transfer Report", routename: "StockTransferReport" },
                { path: "/OrderReport/30/DESC", name: "Orders Report", routename: "OrdersReport" },
                { path: "/PurchaseReturnReports/30/DESC", name: "Purchase Return Report", routename: "PurchaseReturnReport" },
                { path: "/SaleReturnReports/30/DESC", name: "Sales Return Report", routename: "SalesReturnReport" },
                { path: "/ExpensesReports/30/DESC", name: "Expenses Report", routename: "ExpensesReport" },
                { path: "/StockReport/300/DESC", name: "Stock Report", routename: "StockReport" },
                { path: "/StockValuation/300/DESC", name: "Stock Valuation", routename: "StockValuation" },
            ],
        },
        {
            path: "/Settings",
            name: "Settings",
            icon: "pi pi-cog",
            routename: "Settings",
        },
    ];

    const filterRoutesByPermission = (routes, userRoutes) => {
        return routes.map(route => {
            if (route.children) {
                const filteredChildren = filterRoutesByPermission(route.children, userRoutes);
                if (filteredChildren.length > 0) {
                    return { ...route, children: filteredChildren };
                }
                return null;
            }

            return userRoutes.includes(route.routename) ? route : null;
        }).filter(route => route !== null);
    };

    useEffect(() => {
        socket.on("qr_user_list", ({ users }) => {
            setQrUsers(users);
        });

        return () => socket.off("qr_user_list");
    }, []);

    const filteredRoutes = filterRoutesByPermission(routes, userRoutes);

    const renderRoutes = (routes) => {
        return routes.map((route, index) => (
            <li className="nav-item mt-2" key={index}>
                {route.children ? (
                    <div className="nav-section">
                        <div
                            className={`nav-link bg-dark p-3 text-light d-flex justify-content-between align-items-center ${expandedSections[route.name] ? "active" : ""}`}
                            onClick={() => toggleSection(route.name)}>
                            <div>
                                <i className={`${route.icon} me-2`}></i> {route.name}
                            </div>
                            <i className={`pi ${expandedSections[route.name] ? "pi-chevron-down" : "pi-chevron-right"}`}></i>
                        </div>
                        <AnimatePresence>
                            {expandedSections[route.name] && (
                                <motion.ul
                                    className="nav-submenu bg-dark text-light  w-100 shadow"
                                    initial={{ opacity: 0, height: 0 }}
                                    animate={{ opacity: 1, height: "auto" }}
                                    exit={{ opacity: 0, height: 0 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    {route.children.map((child, idx) => (
                                        <li key={idx}>
                                            <NavLink to={child.path} onClick={handleNavLinkClick} className={`nav-link text-light px-3 border-bottom ${location.pathname === child.path ? "active-route" : ""}`}>
                                                {child.name}
                                            </NavLink>
                                        </li>
                                    ))}
                                </motion.ul>
                            )}
                        </AnimatePresence>
                    </div>
                ) : (
                    <NavLink
                        to={route.path}
                        className={`nav-link bg-dark p-3 text-light mt-0 d-flex align-items-center ${location.pathname === route.path ? "active-route" : ""}`}
                        onClick={handleNavLinkClick}
                    >
                        <i className={`${route.icon} me-2`}></i> {route.name}
                    </NavLink>
                )}
            </li>
        ));
    };

    if (auth_routes.length === 0) {
        const textVariants = {
            hidden: { opacity: 0, y: 10 },
            visible: (i = 1) => ({
                opacity: 1,
                y: 0,
                transition: {
                    delay: i * 0.2,
                    duration: 0.5,
                    ease: 'easeOut'
                }
            })
        };
        return (
            <motion.div
                initial={{ opacity: 1, y: 0 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0.5, }}
                transition={{ duration: 0.5, ease: 'easeOut' }}
                className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center"
                style={{ backgroundColor: '#fff', zIndex: 9999 }}
            >
                <ProgressBar
                    mode="indeterminate"
                    style={{ height: '6px', width: '250px', marginBottom: '20px' }}
                />
                <motion.h5
                    className="text-muted"
                    variants={textVariants}
                    initial="hidden"
                    animate="visible"
                    custom={1}
                >
                    Setting up your workspace...
                </motion.h5>

                <motion.p
                    className="text-secondary"
                    style={{ fontSize: '0.9rem' }}
                    variants={textVariants}
                    initial="hidden"
                    animate="visible"
                    custom={2}
                >
                    Please wait while we load your permissions and routes.
                </motion.p>
                <motion.div
                    variants={textVariants}
                    initial="hidden"
                    animate="visible"
                    custom={3}
                    className="d-flex justify-content-center align-items-center gap-3">
                    <button
                        className="btn btn-outline-primary mt-3"
                        onClick={() => window.location.href = '#/Settings'}
                    >
                        Reload
                    </button>
                    <button
                        className="btn btn-danger mt-3"
                        onClick={Logout}
                    >
                        Logout
                    </button>
                </motion.div>
            </motion.div>
        );
    }



    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <nav className="navbar bg-gradient-primary sticky-top shadow">
                <div className="container-fluid">
                    <div className="d-flex align-items-center">
                        <Button
                            icon="pi pi-bars"
                            className="btn-sm bg-dark me-3"
                            onClick={() => setVisible(true)}
                        />
                        <img src={store?.store?.store_logo_url} alt={store?.store?.store_name} width={150} />
                    </div>

                    <div className="d-flex align-items-center gap-3">
                        <div className="select d-flex align-items-center gap-2">

                            <select
                                className="form-select form-select-sm"
                                value={device_id || ""}
                                onChange={(e) => {
                                    set_device_id(e.target.value);
                                }}
                            >
                                <option value="">Select QR Screen</option>

                                {qrUsers.map((u) => (
                                    <option key={u.user_id} value={u.user_id}>
                                        {u.user_name}
                                    </option>
                                ))}
                            </select>

                            <Button
                                icon="pi pi-send"
                                className="p-button-sm p-button-warning"
                                tooltip="Check Device Connection"
                                tooltipOptions={{ position: "bottom" }}
                                onClick={sendMessageToDevice}
                            />

                        </div>
                        {/* Next/Back Buttons */}
                        <Button
                            icon="pi pi-arrow-left"
                            className="p-button-sm p-button-secondary"
                            onClick={() => navigate(-1)}
                            tooltip="Go Back"
                            tooltipOptions={{
                                position: 'bottom'
                            }}
                        />
                        <Button
                            icon="pi pi-arrow-right"
                            iconPos="right"
                            className="p-button-sm p-button-success"
                            tooltip="Go forward"
                            tooltipOptions={{
                                position: 'bottom'
                            }}
                            onClick={() => navigate(1)}
                        />
                        <Button
                            icon={isFullScreen ? "pi pi-window-minimize" : "pi pi-window-maximize"}
                            className="p-button-sm p-button-info"
                            onClick={toggleFullScreen}
                            tooltip={isFullScreen ? "Exit Full Screen" : "Full Screen"}
                            tooltipOptions={{
                                position: 'bottom'
                            }}
                        />

                        {userRoutes.includes("StoreChange") && showStoreSelect && (
                            <div className="select">
                                <StoreSelect setStoreId={set_selected_store_id} storeId={store_id} />
                            </div>
                        )}

                        <div className="profile-dropdown">
                            <Avatar
                                icon="pi pi-user"
                                shape="circle"
                                size="large"
                                onClick={() => setProfileMenuVisible(!profileMenuVisible)}
                            />
                            <AnimatePresence>
                                {profileMenuVisible && (
                                    <motion.div
                                        className="profile-dropdown-menu shadow"
                                        initial={{ opacity: 0, y: -10 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        exit={{ opacity: 0, y: -10 }}
                                        transition={{ duration: 0.2 }}
                                    >
                                        <div className="dropdown-header">
                                            Welcome, {store?.user_name}
                                        </div>
                                        <div
                                            className="dropdown-item"
                                            onClick={() => {
                                                navigate('/Settings');
                                                setProfileMenuVisible(false);
                                            }}
                                        >
                                            <i className="pi pi-cog mr-2"></i>
                                            Settings
                                        </div>
                                        <div
                                            className="dropdown-item"
                                            onClick={handleLogOut}
                                        >
                                            <i className="pi pi-sign-out mr-2"></i>
                                            Logout
                                        </div>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                    </div>
                </div>
            </nav>

            <Sidebar visible={visible} onHide={() => setVisible(false)} className="sidebar-custom">
                <ul className="navbar-nav">{renderRoutes(filteredRoutes)}</ul>
            </Sidebar>
        </>
    );
};

export default Header;
